import React, { useContext } from "react"
import { useHistory, Link } from "react-router-dom"
import Navbar from "react-bootstrap/Navbar"
import Nav from "react-bootstrap/Nav"
import Container from "react-bootstrap/Container"
import "./sidebarStyle.css"
import { userContext } from "../../App"
import logout from "../login/logout"

function Sidebar() {
  const { user, setUser } = useContext(userContext)
  const history = useHistory()
  const onLogout = () => {
    logout(setUser, history)
  }
  return (
    <div className='sidebarStyle'>
      <Navbar
        collapseOnSelect
        expand='lg'
        variant='light'
        className={`navbarStyle`}>
        <Container className='d-flex flex-column'>
          <Navbar.Brand href='/' className='brandStyle'>
            Food App
          </Navbar.Brand>
          <Navbar>
            <Nav className='d-flex flex-column'>
              <Link to='/' className='navLinkStyle'>
                Recipes
              </Link>
              <Link to='/meal-planner' className='navLinkStyle'>
                Meal Planner
              </Link>
              <Link to='/favorites' className='navLinkStyle'>
                Favorites{" "}
              </Link>
              {!user.id ? (
                <Link to='/login' className='navLinkStyle'>
                  Login
                </Link>
              ) : (
                <button className='myBtn p-2' onClick={onLogout}>
                  Log Out
                </button>
              )}
            </Nav>
          </Navbar>
        </Container>
      </Navbar>
    </div>
  )
}
export default Sidebar
